const fieldCard = [
  {
    id: 1,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 1,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "เลขบัตรประชาชน",
    name: "Identity Number",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 1,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 1,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 1,
        billing_field_id: 2,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 1,
        field_condition_type_id: 1,
        value: "Number",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-06-27T15:48:02",
        field_condition_type_name: null,
      },
      {
        id: 2,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 1,
        billing_field_id: 2,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 1,
        field_condition_type_id: 2,
        value: "13",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-06-27T15:48:02",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 1,
        language_id: 1,
        field_id: 1,
        name: "Identity Number",
      },
    ],
  },
  {
    id: 2,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 2,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "คำนำหน้า",
    name: "คำนำหน้า",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 2,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [
      {
        id: 4,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "นางสาว",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 1,
        fix_field_choice_level2_id: 0,
        display_name: "นางสาว/Ms.",
        description: null,
        created_time: "2024-05-14T11:13:00+07:00",
        updated_time: "2024-10-07T15:18:02",
        field_choice_language: [
          {
            id: 1,
            language_id: 1,
            field_choice_id: 4,
            name: "นางสาว/Ms.",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 3,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "นาย",
        sort_order: 1,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 1,
        fix_field_choice_level2_id: 0,
        display_name: "นาย/Mr.",
        description: null,
        created_time: "2024-05-14T11:13:00+07:00",
        updated_time: "2024-10-07T15:18:02",
        field_choice_language: [
          {
            id: 2,
            language_id: 1,
            field_choice_id: 3,
            name: "นาย/Mr.",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 5,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "นาง",
        sort_order: 2,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 1,
        fix_field_choice_level2_id: 0,
        display_name: "นาง/Mrs.",
        description: null,
        created_time: "2024-05-14T11:13:00+07:00",
        updated_time: "2024-06-20T16:12:46",
        field_choice_language: [
          {
            id: 3,
            language_id: 1,
            field_choice_id: 5,
            name: "นาง/Mrs.",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 33957,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "ครู",
        sort_order: 3,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "ครู",
        description: null,
        created_time: "2024-06-24T17:46:55+07:00",
        updated_time: "2024-08-05T17:13:43",
        field_choice_language: [
          {
            id: 4,
            language_id: 1,
            field_choice_id: 33957,
            name: "ครู",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 33958,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "ดาบตำรวจ",
        sort_order: 4,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "ตำรวจ",
        description: null,
        created_time: "2024-06-24T17:46:56+07:00",
        updated_time: "2024-08-05T17:13:44",
        field_choice_language: [
          {
            id: 5,
            language_id: 1,
            field_choice_id: 33958,
            name: "ตำรวจ",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 33959,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "ร้อยโท",
        sort_order: 5,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "ร้อยโท",
        description: null,
        created_time: "2024-06-24T17:46:56+07:00",
        updated_time: "2024-08-05T17:13:44",
        field_choice_language: [
          {
            id: 6,
            language_id: 1,
            field_choice_id: 33959,
            name: "ร้อยโท",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 16461,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "ไม่ระบุ",
        sort_order: 6,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "ไม่ระบุ",
        description: null,
        created_time: "2024-05-21T16:30:40+07:00",
        updated_time: "2024-08-05T17:13:44",
        field_choice_language: [
          {
            id: 7,
            language_id: 1,
            field_choice_id: 16461,
            name: "ไม่ระบุ",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 33978,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "อื่นๆ",
        sort_order: 7,
        is_display: 1,
        choice_type_id: 3,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "อื่นๆ",
        description: "ระบุคำนำหน้า",
        created_time: "2024-06-25T11:18:38+07:00",
        updated_time: "2024-08-05T17:13:44",
        field_choice_language: [
          {
            id: 8,
            language_id: 1,
            field_choice_id: 33978,
            name: "อื่นๆ",
            description: "",
          },
        ],
        denpendent: [],
      },
      {
        id: 33986,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 3,
        shipping_field_id: 2,
        contact_field_id: 1,
        field_id: 2,
        name: "Choice 9",
        sort_order: 8,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "ทดสอบ",
        description: "โปรดระบุ",
        created_time: "2024-10-09T09:57:59+07:00",
        updated_time: "2024-10-09T09:57:59",
        field_choice_language: [
          {
            id: 117,
            language_id: 1,
            field_choice_id: 33986,
            name: "ทดสอบ",
            description: "",
          },
        ],
        denpendent: [],
      },
    ],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 2,
        language_id: 1,
        field_id: 2,
        name: "คำนำหน้า",
      },
    ],
  },

  {
    id: 3,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 3,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "ชื่อ",
    name: "ชื่อ",
    company_name: null,
    validate_text: null,
    is_update: 0,
    is_display: 0,
    isDisabled: true,
    required: true,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 4,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 3,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 3,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:54",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 3,
        language_id: 1,
        field_id: 3,
        name: "ชื่อ",
      },
    ],
  },

  {
    id: 5,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 5,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "นามสกุล",
    name: "นามสกุล",
    company_name: null,
    validate_text: null,
    is_update: 0,
    is_display: 0,
    isDisabled: true,
    required: true,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 6,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 5,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 5,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:54",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 5,
        language_id: 1,
        field_id: 5,
        name: "นามสกุล",
      },
    ],
  },
  {
    id: 4,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 4,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "Name",
    name: "Name",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 7,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 4,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 4,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:54",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 4,
        language_id: 1,
        field_id: 4,
        name: "Name",
      },
    ],
  },

  {
    id: 6,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 6,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "Surname",
    name: "Surname",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 9,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 6,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 6,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:54",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 6,
        language_id: 1,
        field_id: 6,
        name: "Surname",
      },
    ],
  },
  {
    id: 11,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 11,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "อีเมล",
    name: "Email",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: false,
    required: true,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 12,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 13,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 11,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:56",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 11,
        language_id: 1,
        field_id: 11,
        name: "Email",
      },
    ],
  },
  {
    id: 9,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 7,
    field_profile_email_type_id: 0,
    field_profile_type_id: 9,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "วันเกิด",
    name: "Date of Birth",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: true,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 13,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 9,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 9,
        field_condition_type_id: 7,
        value: "100",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2025-03-06T20:24:08",
        field_condition_type_name: null,
      },
      {
        id: 26,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 9,
        field_condition_type_id: 7,
        value: "18",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2025-03-03T12:14:41",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 10,
        language_id: 1,
        field_id: 9,
        name: "Date of Birth",
      },
    ],
  },
  {
    id: 21,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 21,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "เพศ",
    name: "Gender",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 14,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 9,
        language_id: 1,
        field_id: 21,
        name: "Gender",
      },
    ],
  },
  {
    id: 10,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 10,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "เบอร์โทรศัพท์",
    name: "Phone No.",
    company_name: null,
    validate_text: null,
    is_update: 0,
    is_display: 0,
    isDisabled: false,
    required: true,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 15,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 11,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 10,
        billing_field_id: 7,
        shipping_field_id: 6,
        contact_field_id: 7,
        field_id: 10,
        field_condition_type_id: 1,
        value: "Number",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-06-27T17:45:46",
        field_condition_type_name: null,
      },
      {
        id: 12,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 10,
        billing_field_id: 7,
        shipping_field_id: 6,
        contact_field_id: 7,
        field_id: 10,
        field_condition_type_id: 2,
        value: "10",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-06-27T17:45:46",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 12,
        language_id: 1,
        field_id: 10,
        name: "Phone No.",
      },
    ],
  },
  {
    id: 22,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 22,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "เบอร์โทรศัพท์ (สำรอง)",
    name: "เบอร์โทรศัพท์ (สำรอง)",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 0,
    show_on_edit_profile: 1,
    sort_order: 16,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 13,
        language_id: 1,
        field_id: 22,
        name: "เบอร์โทรศัพท์ (สำรอง)",
      },
    ],
  },
  {
    id: 30,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 16,
    field_profile_email_type_id: 0,
    field_profile_type_id: 24,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "ประเทศ",
    name: "ประเทศ",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 18,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 15,
        language_id: 1,
        field_id: 24,
        name: "ประเทศ",
      },
    ],
  },
  {
    id: 12,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 12,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "บ้านเลขที่",
    name: "บ้านเลขที่",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 19,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 14,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 12,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:56",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 16,
        language_id: 1,
        field_id: 12,
        name: "บ้านเลขที่",
      },
    ],
  },

  {
    id: 14,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 14,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "ซอย",
    name: "ซอย",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 21,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 16,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 14,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:57",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 18,
        language_id: 1,
        field_id: 14,
        name: "ซอย",
      },
    ],
  },
  {
    id: 15,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 15,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "ถนน",
    name: "ถนน",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 22,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 17,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 15,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T13:39:57",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 19,
        language_id: 1,
        field_id: 15,
        name: "ถนน",
      },
    ],
  },
  {
    id: 18,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 15,
    field_profile_email_type_id: 0,
    field_profile_type_id: 18,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "จังหวัด",
    name: "จังหวัด",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 23,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 17,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 20,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 18,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T11:32:19",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 20,
        language_id: 1,
        field_id: 18,
        name: "จังหวัด",
      },
    ],
  },
  {
    id: 17,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 15,
    field_profile_email_type_id: 0,
    field_profile_type_id: 17,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "เขต",
    name: "เขต",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 24,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 16,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 19,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 17,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T11:32:06",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 21,
        language_id: 1,
        field_id: 17,
        name: "เขต",
      },
    ],
  },
  {
    id: 16,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 15,
    field_profile_email_type_id: 0,
    field_profile_type_id: 16,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    name: "แขวง / ตำบล",
    name: "แขวง / ตำบล",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 25,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 19,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [
      {
        id: 18,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 16,
        field_condition_type_id: 1,
        value: "text",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T11:29:57",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 22,
        language_id: 1,
        field_id: 16,
        name: "แขวง / ตำบล",
      },
    ],
  },
  {
    id: 19,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 19,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "รหัสไปรษณีย์",
    name: "รหัสไปรษณีย์",
    company_name: null,
    validate_text: null,
    is_update: 1,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 0,
    sort_order: 26,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 2,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [
      {
        id: 16474,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10200",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16475,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10300",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16476,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10530",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16477,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10500",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16478,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16479,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16480,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16481,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16482,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16483,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10510",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16484,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10520",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16485,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16486,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10400",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16487,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10600",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16488,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16489,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16490,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10700",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16491,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16492,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16493,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16494,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10800",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16495,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10900",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16496,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16497,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16498,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16499,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16500,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16501,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16502,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10560",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16503,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10550",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16504,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10540",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16505,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16506,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "10290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16507,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "11000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16508,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "11130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16509,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "11140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16510,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "11110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16511,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "11150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16512,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "11120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16513,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16514,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16515,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16516,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16517,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16518,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16519,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16520,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "12160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16521,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16522,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16523,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16524,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16525,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16526,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16527,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16528,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16529,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16530,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16531,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16532,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16533,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16534,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16535,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16536,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16537,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16538,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16539,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "13240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16540,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16541,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16542,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16543,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16544,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16545,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16546,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "14160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16547,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16548,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16549,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16550,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16551,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16552,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16553,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16554,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16555,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16556,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16557,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16558,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16559,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16560,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16561,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "15170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16562,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16563,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16564,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16565,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16566,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16567,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16568,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "16110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16569,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16570,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16571,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16572,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16573,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16574,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16575,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16576,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "17160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16577,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16578,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16579,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16580,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16581,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16582,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16583,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16584,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16585,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16586,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16587,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16588,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16589,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16590,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16591,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16592,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "18240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16593,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16594,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16595,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16596,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16597,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16598,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16599,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16600,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16601,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16602,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16603,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16604,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16605,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16606,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16607,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "20240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16608,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16609,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16610,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16611,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16612,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16613,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16614,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16615,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16616,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16617,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16618,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16619,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16620,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "21180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16621,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16622,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16623,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16624,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16625,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16626,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16627,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16628,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16629,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16630,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "22210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16631,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16632,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16633,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16634,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16635,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16636,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16637,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "23170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16638,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16639,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16640,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16641,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16642,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16643,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16644,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16645,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16646,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16647,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "24190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16648,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16649,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16650,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16651,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16652,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16653,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16654,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16655,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16656,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "25190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16657,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "26000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16658,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "26130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16659,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "26110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16660,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "26120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16661,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16662,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16663,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16664,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16665,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16666,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16667,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "27250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16668,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16669,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16670,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16671,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16672,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16673,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16674,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16675,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16676,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16677,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16678,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16679,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16680,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16681,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16682,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16683,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16684,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16685,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16686,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16687,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16688,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16689,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30380",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16690,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16691,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16692,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16693,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16694,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30410",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16695,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30440",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16696,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30360",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16697,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30370",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16698,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "30430",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16699,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16700,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16701,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16702,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16703,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16704,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16705,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16706,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16707,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16708,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16709,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16710,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16711,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16712,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16713,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16714,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "31260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16715,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16716,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16717,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16718,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16719,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16720,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16721,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16722,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16723,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16724,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16725,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16726,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16727,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "32230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16728,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16729,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16730,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16731,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16732,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16733,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16734,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16735,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16736,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16737,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16738,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16739,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16740,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16741,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16742,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16743,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "33230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16744,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16745,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16746,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16747,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16748,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16749,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16750,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16751,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16752,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16753,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16754,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16755,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16756,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16757,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16758,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16759,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16760,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16761,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16762,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34360",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16763,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "34350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16764,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16765,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16766,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16767,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16768,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16769,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16770,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16771,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16772,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "35120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16773,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16774,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16775,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16776,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16777,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16778,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16779,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16780,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16781,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16782,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16783,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16784,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16785,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16786,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16787,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "36260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16788,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "37000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16789,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "37210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16790,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "37110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16791,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "37180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16792,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "37290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16793,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "37240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16794,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16795,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16796,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16797,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16798,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16799,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16800,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "38190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16801,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "39000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16802,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "39170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16803,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "39350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16804,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "39140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16805,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "39180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16806,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "39270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16807,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16808,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16809,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16810,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16811,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16812,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16813,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16814,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16815,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16816,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16817,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16818,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16819,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16820,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16821,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16822,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16823,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16824,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16825,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16826,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16827,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16828,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16829,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16830,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "40350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16832,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16833,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16834,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16835,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41360",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16836,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16837,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16838,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41370",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16839,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16840,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16841,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16842,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16843,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16844,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16845,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16846,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16847,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16848,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16849,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16850,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16851,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16852,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "41380",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16853,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16854,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16855,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16856,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16857,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16858,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16859,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16860,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16861,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16862,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16863,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16864,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16865,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16866,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16867,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "42190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16868,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "43000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16869,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "43100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16870,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "43110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16871,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "43120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16872,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "43130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16873,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "43160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16874,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16875,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16876,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16877,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16878,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16879,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16880,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16881,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16882,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16883,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16884,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "44210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16885,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16886,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16887,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16888,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16889,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16890,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16891,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16892,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16893,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16894,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16895,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16896,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16897,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16898,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16899,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16900,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "45280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16901,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16902,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16903,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16904,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16905,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16906,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16907,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16908,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16909,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16910,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16911,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16912,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16913,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16914,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "46240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16915,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16916,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16917,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16918,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16919,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16920,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16921,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16922,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16923,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16924,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16925,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16926,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16927,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16928,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16929,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16930,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16931,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16932,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16933,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "47290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16934,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16935,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16936,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16937,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16938,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16939,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16940,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16941,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16942,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16943,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "48190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16944,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16945,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16946,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16947,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16948,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16949,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16950,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "49160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16951,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50200",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16952,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16953,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50300",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16954,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16955,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16956,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16957,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16958,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "58130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16959,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16960,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16961,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16962,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16963,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16964,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16965,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16966,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16967,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16968,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16969,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16970,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16971,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16972,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16973,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16974,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16975,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16976,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16977,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16978,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16979,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "50360",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16980,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16981,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16982,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16983,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16984,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16985,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16986,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16987,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16988,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "51180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16989,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16990,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16991,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16992,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16993,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16994,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16995,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16996,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16997,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16998,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 16999,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17000,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17001,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17002,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17003,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "52240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17004,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17005,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17006,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17007,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17008,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17009,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17010,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17011,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17012,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17013,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17014,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17015,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17016,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "53230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17017,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17018,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17019,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17020,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17021,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17022,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17023,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17024,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "54170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17025,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17026,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17027,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17028,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17029,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17030,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17031,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17032,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17033,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17034,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17035,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17036,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "55220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17037,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17038,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17039,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17040,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17041,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17042,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17043,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "56130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17044,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17045,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17046,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17047,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17048,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17049,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17050,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17051,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17052,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17053,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17054,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17055,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17056,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17057,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17058,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17059,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17060,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17061,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17062,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17063,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17064,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17065,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "57340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17066,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "58000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17067,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "58140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17068,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "58110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17069,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "58120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17070,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "58150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17071,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17072,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17073,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17074,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17075,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17076,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17077,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17078,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17079,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17080,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17081,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17082,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17083,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17084,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17085,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17086,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "60190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17087,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17088,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17089,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17090,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17091,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17092,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17093,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17094,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17095,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "61160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17096,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17097,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17098,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17099,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17100,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17101,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17102,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17103,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17104,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17105,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17106,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "62210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17107,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17108,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17109,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17110,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17111,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17112,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17113,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17114,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "63170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17115,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17116,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17117,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17118,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17119,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17120,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17121,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17122,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17123,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17124,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17125,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17126,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17127,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "64150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17128,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17129,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17130,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17131,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17132,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17133,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17134,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17135,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17136,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17137,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17138,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17139,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17140,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17141,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "65190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17142,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17143,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17144,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17145,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17146,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17147,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17148,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17149,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17150,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17151,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17152,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17153,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17154,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "66220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17155,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17156,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17157,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17158,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17159,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17160,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17161,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17162,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17163,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17164,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17165,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17166,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17167,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17168,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17169,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17170,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17171,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17172,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "67280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17173,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17174,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17175,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17176,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17177,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17178,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17179,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17180,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17181,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17182,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17183,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "70170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17184,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17185,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17186,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17187,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17188,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17189,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17190,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17191,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17192,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17193,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17194,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17195,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17196,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17197,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17198,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "71260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17199,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17200,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17201,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17202,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17203,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17204,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17205,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17206,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17207,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17208,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17209,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17210,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17211,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17212,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17213,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "72240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17214,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17215,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17216,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17217,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17218,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17219,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17220,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17221,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17222,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17223,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17224,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17225,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "73170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17226,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "74000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17227,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "74110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17228,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "74130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17229,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "74120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17230,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "75000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17231,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "75120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17232,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "75110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17233,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17234,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17235,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17236,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17237,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17238,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17239,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17240,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17241,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "76170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17242,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17243,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17244,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17245,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17246,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17247,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17248,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17249,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17250,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17251,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17252,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17253,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "77180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17254,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17255,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17256,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17257,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17258,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17259,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17260,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17261,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17262,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17263,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17264,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17265,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17266,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17267,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17268,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17269,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17270,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17271,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17272,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17273,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17274,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17275,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17276,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17277,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17278,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "80360",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17279,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17280,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17281,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17282,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17283,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17284,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17285,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17286,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "81130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17287,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17288,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17289,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "83000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17290,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17291,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17292,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17293,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17294,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17295,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17296,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17297,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "82120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17298,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "83130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17299,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "83100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17300,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "83120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17301,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "83150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17302,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "83110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17303,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17304,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17305,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84290",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17306,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17307,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17308,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84340",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17309,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17310,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17311,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17312,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17313,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17314,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17315,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17316,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17317,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17318,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17319,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17320,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17321,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17322,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17323,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17324,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17325,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17326,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17327,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "84350",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17328,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "85000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17329,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "85130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17330,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "85120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17331,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "85110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17332,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17333,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17334,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17335,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17336,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17337,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17338,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17339,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17340,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17341,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17342,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17343,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17344,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17345,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "86220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17346,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17347,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90100",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17348,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17349,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17350,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17351,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17352,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90260",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17353,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17354,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17355,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90270",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17356,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17357,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17358,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17359,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90240",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17360,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90320",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17361,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17362,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90250",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17363,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17364,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90310",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17365,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17366,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90280",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17367,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90330",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17368,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "90115",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17369,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17370,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17371,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17372,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17373,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17374,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17375,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "91120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17376,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17377,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17378,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17379,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17380,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17381,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17382,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17383,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17384,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17385,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17386,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17387,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "92160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17388,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17389,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17390,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17391,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17392,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17393,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17394,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17395,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17396,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17397,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "93140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17398,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17399,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17400,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17401,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17402,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17403,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17404,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17405,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17406,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17407,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17408,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17409,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "94230",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17410,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17411,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17412,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17413,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17414,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17415,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17416,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17417,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "95140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17418,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96000",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17419,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96110",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17420,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96170",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17421,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96180",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17422,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96130",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17423,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96220",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17424,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96150",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17425,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96210",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17426,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96160",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17427,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96190",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17428,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96120",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
      {
        id: 17429,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 19,
        billing_field_id: 16,
        shipping_field_id: 16,
        contact_field_id: 17,
        field_id: 19,
        name: "96140",
        sort_order: 0,
        is_display: 1,
        choice_type_id: 1,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        fix_field_choice_level2_id: 0,
        display_name: "",
        description: null,
        created_time: "2024-05-24T13:58:55+07:00",
        updated_time: "2024-05-24T14:07:13",
        field_choice_language: [],
        denpendent: [],
      },
    ],
    field_conditions: [
      {
        id: 21,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 19,
        field_condition_type_id: 1,
        value: "Number",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T11:32:19",
        field_condition_type_name: null,
      },
      {
        id: 22,
        register_form_field_id: 0,
        register_email_form_field_id: 0,
        company_form_field_id: 0,
        company_field_id: 0,
        billing_field_id: 0,
        shipping_field_id: 0,
        contact_field_id: 0,
        field_id: 19,
        field_condition_type_id: 2,
        value: "5",
        created_time: "2021-09-07T16:07:50+07:00",
        updated_time: "2024-05-10T11:32:19",
        field_condition_type_name: null,
      },
    ],
    user_answer: null,
    field_language: [
      {
        id: 23,
        language_id: 1,
        field_id: 19,
        name: "รหัสไปรษณีย์",
      },
    ],
  },

  {
    id: 36,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 5,
    field_profile_email_type_id: 0,
    field_profile_type_id: 35,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "วันออกบัตรประชาชน",
    name: "วันออกบัตรประชาชน / Issue Date ID Card (Date)",
    company_name: null,
    validate_text: null,
    is_update: 0,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 28,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 226,
        language_id: 1,
        field_id: 35,
        name: "วันออกบัตรประชาชน / Issue Date ID Card",
      },
    ],
  },
  {
    id: 37,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 5,
    field_profile_email_type_id: 0,
    field_profile_type_id: 36,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "วันหมดอายุบัตรประชาชน",
    name: "วันหมดอายุบัตรประชาชน / Expire Date ID Card (Date)",
    company_name: null,
    validate_text: null,
    is_update: 0,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 29,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 227,
        language_id: 1,
        field_id: 36,
        name: "วันหมดอายุบัตรประชาชน / Expire Date ID Card",
      },
    ],
  },
  {
    id: 35,
    is_field_used_count: 0,
    booking_id: 0,
    from_id: 0,
    field_id: 0,
    field_type_id: 1,
    field_profile_email_type_id: 0,
    field_profile_type_id: 34,
    field_company_type_id: 0,
    field_billing_type_id: 0,
    field_shipping_type_id: 0,
    field_contact_type_id: 0,
    branch_group_id: 0,
    banner: null,
    profile_name: "สถานที่ออกบัตรประชาชน",
    name: "สถานที่ออกบัตรประชาชน",
    company_name: null,
    validate_text: null,
    is_update: 0,
    is_display: 0,
    isDisabled: true,
    required: false,
    is_profile_required: false,
    is_profile: false,
    is_show: 1,
    show_on_edit_profile: 1,
    sort_order: 27,
    parent_choice_id: 0,
    parent_field_id: 0,
    group_field_id: 0,
    is_person: 0,
    is_company: 0,
    is_billing: 0,
    is_shipping: 0,
    is_contact: 0,
    social_media_type: 0,
    group_id: 1,
    field_dependent: 0,
    created_time: "0001-01-01T00:00:00",
    updated_time: "0001-01-01T00:00:00",
    select_branch: null,
    field_choices: [],
    field_conditions: [],
    user_answer: null,
    field_language: [
      {
        id: 225,
        language_id: 1,
        field_id: 34,
        name: "สถานที่ออกบัตรประชาชน / Issue Place ID Card",
      },
    ],
  },
];

export { fieldCard };
